import axios, { type AxiosResponse } from 'axios';
import { CollaborationForm } from '../type';
import { CollaborationTypeS } from '../outbound/share';

export const postCollaboration = (params: CollaborationForm) => {
  return axios.post<void, AxiosResponse<CollaborationTypeS.CollaborationResponse>, CollaborationForm>(
    '/@api/proposal_collaboration',
    params,
  );
};
